/**
 * Build a Cornerstone annotation UID for a hydrated report measurement.
 *
 * UIDs MUST include `studyUuid`: Cornerstone's `annotation.state` is a global
 * singleton, so without study scoping, two studies with the same
 * `canonicalMeasurement` collide and only one renders.
 */
export function hydratedAnnotationUid(
  studyUuid: string,
  canonicalMeasurement: string
): string {
  return `hydrated-${studyUuid}-${canonicalMeasurement}`;
}

/** AI variant of {@link hydratedAnnotationUid}. */
export function aiHydratedAnnotationUid(
  studyUuid: string,
  canonicalMeasurement: string
): string {
  return `ai-hydrated-${studyUuid}-${canonicalMeasurement}`;
}
